const applyAssistantDelta = ({ threadId, eventId, delta, textOffset } = {}) => {
  return {
    type: 'pieveApplyAssistantDelta',
    payload: { threadId, eventId, delta, ...(textOffset !== undefined ? { textOffset } : {}) }
  };
};

export default applyAssistantDelta;
